var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LevellingPageShell',{attrs:{"title":"Levelling Framework","icon":"mdi-view-grid-outline"}},[_c('LevellingFramework',_vm._g(_vm._b({attrs:{"hideTitle":""}},'LevellingFramework',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }